import React, {useState, useEffect} from "react";
import { LoadingSpinner } from "../partials/LoadingSpinner";
import { Modal } from "../../Global/Modal/Modal";
import { SINGLE_PASSWORD_VALIDATION, EMAIL_VALIDATION, GET_TOKEN, OBJECT_EMPTY, GET_USER_LEVEL} from "../../../helpers";
import { POST_USER_NEW_PASS, POST_USER_NEW_EMAIL, API_URL,
GET_ME, POST_ME } from "../../../constants";

import "./UserSettings.css";

export const UserSettings = () => {
  
  const [dataLoaded, setDataLoaded] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [triggerMe, setTriggerMe] = useState(false)

  const [emailError, setEmailError] = useState('');
  const [emailButtonDisabled, setEmailButtonDisabled] = useState(true)
  const [modalActiveEmail, setModalActiveEmail] = useState(false)
  const [modalEmailFields, setModalEmailFields] = useState({
    email: '',
    newEmail: '',
    password: ''
  })

  const [passwordError, setPasswordError] = useState('');
  // const [passButtonDisabled, setPassButtonDisabled] = useState(true)
  const [modalActivePassword, setModalActivePassword] = useState(false)
  const [modalPasswordFields, setModalPasswordFields] = useState({
    oldPass: '',
    newPass: '',
    confirmNewPass: '',
  })

  const [emailNotifications, setEmailNotifications] = useState({
    notifications_treshold: false,
    notifications_billing: false,
    notifications_promotional: false,
    notifications_return: false
  })

  // Email Pass disable
  useEffect(() => {
    if (modalEmailFields.password.length < 8) return setEmailButtonDisabled(true)
    if (modalEmailFields.email !== modalEmailFields.newEmail) return setEmailButtonDisabled(true)
    if (!EMAIL_VALIDATION(modalEmailFields.newEmail)) return setEmailButtonDisabled(true)

    setEmailButtonDisabled(false)
  }, [modalEmailFields])

  // New pass disable
  // useEffect(() => {
  //   if (modalPasswordFields.oldPass.length <= 0) return setPassButtonDisabled(true)
  //   if (modalPasswordFields.confirmNewPass !== modalPasswordFields.newPass) return setPassButtonDisabled(true)
  //   if (!SINGLE_PASSWORD_VALIDATION(modalPasswordFields.newPass)) return setPassButtonDisabled(true)
  //   if (!SINGLE_PASSWORD_VALIDATION(modalPasswordFields.confirmNewPass)) return setPassButtonDisabled(true)

  //   setPassButtonDisabled(false);
  // }, [modalPasswordFields])

  // onChange clear all errors
  useEffect(() => {
    setEmailError('')
  }, [modalEmailFields])

  useEffect(() => {
    fetch(API_URL + GET_ME, {
      method: "GET",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((data) => {


        setEmailNotifications({
          notifications_treshold: data.notifications_treshold,
          notifications_billing: data.notifications_billing,
          notifications_promotional: data.notifications_promotional,
          notifications_return: data.notifications_return,
        })
      })

    return () => {
      setPasswordError('')
    }
  }, [])

  useEffect(() => {
    setTriggerMe(!triggerMe)
    setModalPasswordFields({
      oldPass: '',
      newPass: '',
      confirmNewPass: '',
    })

    setModalEmailFields({
      email: '',
      newEmail: '',
      password: ''
    })
  }, [modalActiveEmail, modalActivePassword])

  // GET me
  useEffect(() => {
    if (OBJECT_EMPTY(userInfo)) {
      fetch(API_URL + GET_ME, {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
      })
        .then((response) => response.json())
        .then((data) => setUserInfo(data))
        .then(() => setDataLoaded(true));
    }
  // eslint-disable-next-line
  }, [triggerMe]);

  const submitNotifications = (type, bool) => {
    const body = JSON.stringify({
      [type]: bool
    })

    fetch(API_URL + POST_ME, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: body,
    })
    .then(() => setEmailNotifications({ ...emailNotifications, [type]: bool }))
    .catch(error => console.log(error));
  }

  const submitNewPassword = () => {
    const body = JSON.stringify({
      password_old: modalPasswordFields.oldPass,
      password: modalPasswordFields.confirmNewPass
    })

    fetch(API_URL + POST_USER_NEW_PASS, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {
      response.error 
        ? setPasswordError(response.error)
        : setModalActivePassword(false)
    })
    .catch(error => console.log(error));
  };

  const submitNewEmail = () => {
    const body = JSON.stringify({
      email: modalEmailFields.newEmail,
      password: modalEmailFields.password
    })

    fetch(API_URL + POST_USER_NEW_EMAIL, {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
      body: body,
    })
    .then((response) => response.json())
    .then((response) => {
      response.error 
        ? setEmailError(response.error)
        : setModalActiveEmail(false);
    })
    .catch(error => console.log(error));
  };

  const companiesList = () => {
    let newString = ''

    if (userInfo.companies) {
      return userInfo.companies?.map((item, i) => {
        return item.name !== null
          ? newString = newString + item.name + (userInfo.companies.length !== (i+1) ? ', ' : '')
          : newString = newString + `Company id:${item.id}${userInfo.companies.length !== (i+1) ? ', ' : ''}`
        })
    }
   
    return newString
  }

  const SettingSideBlock = () => {
    return <div className="UserSettings__content">
      <div className="UserSettings__side-block">
        <div className="Dashboard__content__top-row">
          <h2>General Settings</h2>
        </div>
  
        <ul>
          <li>
            Account type {userInfo.type && <b>{userInfo.type === 'type1' ? 'Regular' : 'Corporate'}</b>}
          </li>

          <li>
            Company (-ies) <b>{userInfo?.company?.name || ''}</b>
          </li>

          <li>
            <table className="default-table">
              <tbody>
                <tr>
                  <th>
                    Email Address (Login, Notifications)
                  </th>
                </tr>

                <tr>
                  <td>{userInfo.email && userInfo.email}</td>
                  <td>
                    <button onClick={() => !modalActiveEmail && setModalActiveEmail(true)}>Change</button>
                    
                    <Modal
                      ModalOpen={modalActiveEmail}
                      ModalOpenHandler={(value) => setModalActiveEmail(value)}
                      closeButton={true}
                      customClassName={'modal__form_newemail'}
                      title={'Update current email'}
                    >

                      <input 
                        type="text"
                        placeholder='New Email'
                        className='default-input'
                        value={modalEmailFields.email}
                        onChange={(e) => setModalEmailFields({
                          ...modalEmailFields,
                          email: e.target.value
                        })}
                      />

                      <input 
                        type="text"
                        placeholder='Confirm Email'
                        className='default-input'
                        value={modalEmailFields.newEmail}
                        onChange={(e) => setModalEmailFields({
                          ...modalEmailFields,
                          newEmail: e.target.value
                        })}
                      />
                      
                      <input 
                        type="password"
                        placeholder='Password'
                        className='default-input'
                        value={modalEmailFields.password}
                        onChange={(e) => setModalEmailFields({
                          ...modalEmailFields,
                          password: e.target.value
                        })}
                      />

                      {emailError && <p className="error-message">{emailError}</p>}

                      <div className="Modal__submit-wrapper">
                        <button 
                          onClick={submitNewEmail}
                          disabled={emailButtonDisabled}
                        >
                          submit
                        </button>
                      </div>
                    </Modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </li>

          <li>
            <table className="default-table">
              <tbody>
                <tr>
                  <th>
                    Password
                  </th>
                </tr>

                <tr>
                  <td>*********</td>
                  <td>

                  <button onClick={() => !modalActivePassword && setModalActivePassword(true)}>Change</button>         
                    <Modal
                      ModalOpen={modalActivePassword}
                      ModalOpenHandler={(value) => setModalActivePassword(value)}
                      closeButton={true}
                      customClassName={'modal__form_newemail'}
                      title={'Update current password'}
                    >

                      <input 
                        type="password"
                        placeholder='Current password'
                        className='default-input'
                        value={modalPasswordFields.oldPass}
                        onFocus={() => {
                          setPasswordError('')
                        }}
                        onChange={(e) => setModalPasswordFields({
                          ...modalPasswordFields,
                          oldPass: e.target.value
                        })}
                      />

                      <input 
                        type="password"
                        placeholder='New Password'
                        className='default-input'
                        value={modalPasswordFields.newPass}
                        onChange={(e) => setModalPasswordFields({
                          ...modalPasswordFields,
                          newPass: e.target.value
                        })}
                        onFocus={() => {
                          setPasswordError('')
                        }}
                      />

                      <p className="Input_helper">8+ characters, at least one number, letter and symbol</p>
                      
                      <input 
                        type="password"
                        placeholder='Confirm New Password'
                        className='default-input'
                        value={modalPasswordFields.confirmNewPass}
                        onChange={(e) => setModalPasswordFields({
                          ...modalPasswordFields,
                          confirmNewPass: e.target.value
                        })}
                        onFocus={() => {
                          setPasswordError('')
                        }}
                      />

                      {passwordError && <p className="error-message">{passwordError}</p>}

                      <div className="Modal__submit-wrapper">
                        <button 
                          onClick={() => {
                            if (
                              modalPasswordFields.oldPass.length > 1 && 
                              modalPasswordFields.newPass.length > 1 && 
                              modalPasswordFields.newPass === modalPasswordFields.confirmNewPass 
                              && SINGLE_PASSWORD_VALIDATION(modalPasswordFields.newPass) 
                            ) {
                              submitNewPassword()
                            } else {

                              if (modalPasswordFields.newPass !== modalPasswordFields.confirmNewPass) {
                                setPasswordError('New passwords do not match.')
                              } 
                              
                              else if (!SINGLE_PASSWORD_VALIDATION(modalPasswordFields.newPass)) {
                                setPasswordError('New password must contain 8+ characters, at least one number, letter and a symbol')
                              }

                              else if (modalPasswordFields.oldPass.length <= 1) {
                                setPasswordError('Please enter current password.')
                              } 

                              else {
                                setPasswordError('Wrong password')
                              }
                            }
                          }}
                        >
                          submit
                        </button>
                      </div>
                    </Modal>
                  </td>
                </tr>
              </tbody>
            </table>
          </li>

          {/* <li>
            <label className="checkbox-label">
              <input type="checkbox" name="developer_menu"></input>
                Show developer menu
            </label>
          </li> */}
        </ul>
      </div>

      <div className="UserSettings__side-block">
        <div className="Dashboard__content__top-row">
          <h2>Email Notification Settings</h2>
        </div>

        <ul>
          <li>
            <label className="checkbox-label">
              <input type="checkbox" name="notifications_treshold"
                checked={emailNotifications.notifications_treshold}
                onChange={() => {
                  submitNotifications('notifications_treshold', !emailNotifications.notifications_treshold)
                }}/>
              Treshold notifications
            </label>
          </li>
          <li>
            <label className="checkbox-label">
              <input type="checkbox" name="notifications_billing" 
                checked={emailNotifications.notifications_billing} 
                onChange={() => {
                  submitNotifications('notifications_billing', !emailNotifications.notifications_billing)
                }}/>
              Billing notifications
            </label>
          </li>
          <li>
            <label className="checkbox-label">
              <input type="checkbox" name="promotional" 
                checked={emailNotifications.notifications_promotional} 
                onChange={() => {
                  submitNotifications('notifications_promotional', !emailNotifications.notifications_promotional)
                }}/>
              Promotional notifications
            </label>
          </li>
          <li>
            <label className="checkbox-label">
              <input type="checkbox" name="return" 
                checked={emailNotifications.notifications_return} 
                onChange={() => {
                  submitNotifications('notifications_return', !emailNotifications.notifications_return)
                }}/>
              Returns notifications
            </label>
          </li>
        </ul>
      </div>
  </div>
  }

  return (
    <div className="UserSettings">

        {!OBJECT_EMPTY(userInfo) && dataLoaded
          ? SettingSideBlock()
          : dataLoaded 
            ? <div className="loading">No Data Found</div>
            : <LoadingSpinner/>}
    </div>
  );
};
